import { gql } from 'apollo-boost';

export default gql`
  mutation DeleteTheme($where: theme_bool_exp!) {
    delete_theme(where: $where) {
      affected_rows
    }
  }
`;
